import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { DepartmentService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DepartmentCreateDto,
  DepartmentDto,
  DepartmentExcelDownloadDto,
  DepartmentUpdateDto,
} from '../proxy/planning/dtos/department';
import { DEPARTMENT_CONFIG, DEPARTMENT_FIELDS } from './department.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-department',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DepartmentService, ConfirmationService],
  templateUrl: './department.html',
  styleUrl: './department.scss',
})
export class Department extends BaseHierarchicalCrudComponent<
  DepartmentDto,
  DepartmentCreateDto,
  DepartmentUpdateDto,
  DepartmentExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(DepartmentService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Department', ids),
  };
  config = DEPARTMENT_CONFIG;
  fields = DEPARTMENT_FIELDS;

  protected prepareUpdateDto(data: any, selected: DepartmentDto): DepartmentUpdateDto {
    return {
      name: data.name,
      code: data.code,
      countryId: data.countryId,
      locationId: data.locationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Department';
  }
}
